import { Box, Chip, Stack, Typography, alpha, styled } from "@mui/material"
import {
  EvolutionStatChip,
  type IconUrl,
  type KeyFigureOrNull,
  formatPrice,
  isDefined,
  noDecimalsFormatOptions,
} from "@pharmupp/p3-front-commons"
import type { Icon as FeatherIcon } from "react-feather"

// ---------------- [CHIP] ----------------
export const SalesDetailsSummaryAmountChip = ({
  amount,
}: { amount: KeyFigureOrNull }) => {
  return (
    <AmountChip
      label={
        isDefined(amount?.mainStat)
          ? formatPrice(amount.mainStat, noDecimalsFormatOptions)
          : "-"
      }
    />
  )
}
const AmountChip = styled(Chip)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.common.darkBlue,
  fontWeight: 600,
  fontSize: theme.typography.pxToRem(20),
}))

// ---------------- [TITLE] ----------------
const ICON_SIZE = 25
interface SalesDetailsSummaryTitleProps {
  Icon: FeatherIcon | IconUrl
  label: string
}
export const SalesDetailsSummaryTitle = ({
  Icon,
  label,
}: SalesDetailsSummaryTitleProps) => {
  return (
    <Stack direction="row" gap={1.75} alignItems="center">
      <IconContainer>
        <Icon size={ICON_SIZE} />
      </IconContainer>
      <Title>{label}</Title>
    </Stack>
  )
}
const IconContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  backgroundColor: alpha(theme.palette.common.rareBlue, 0.1),
  color: theme.palette.common.rareBlue,
  borderRadius: ICON_SIZE * 2,
}))
const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.common.darkBlue,
}))

// ---------------- [EVOLUTION] ----------------
export const SalesDetailsSummaryEvolution = ({
  total,
  upp,
}: { total: KeyFigureOrNull; upp: KeyFigureOrNull }) => (
  <Stack direction="row" gap={1.25} alignItems="center" flex={1}>
    <EvolutionStatChip evol={total?.evolution} />
    <EvolutionStatChip evol={upp?.evolution} isNeutral endLabel="PharmUPP" />
  </Stack>
)
